import { Outlet } from 'react-router-dom'
import { Dispatch } from "redux"
import { useDispatch, useSelector } from 'react-redux'

import Navbar from '../../components/nav/navbar'
import SocialMediaIcons from '../../components/social_media_icons/socialMediaIcons'
import PageIndicator from '../../components/page_indicator/pageIndicator'
import { IActivePage } from '../../interfaces/ActivePage'
import { RootState } from '../../redux/root_reducer'
import { useEffect } from 'react'
import { updatePageTitle } from '../../redux/active_page/actions'

const Layout = () => {
	const state = useSelector((state: RootState) => state.activePage);

	return (
		<div className="container">
			<Navbar></Navbar>

			<div className="header">
				<SocialMediaIcons></SocialMediaIcons>

				{/* <!-- Router Outlet --> */}
				<Outlet></Outlet>

				<PageIndicator pageName={state.title}></PageIndicator>
			</div>
		</div>
	)
}

export default Layout